import { gql } from '@apollo/client';

export const isEmailAvailable = gql`
  query IsEmailAvailable($email: String!) {
    isEmailAvailable(email: $email)
  }
`;
